export default "__VITE_ASSET__mdfQ0EQSrVJVp3yHbBUGNA__";